// extracted by mini-css-extract-plugin
module.exports = {"main":"Recommended_main__DFCvP","listingsGrid":"Recommended_listingsGrid__1p_GI","listing":"Recommended_listing__mLZpC","header":"Recommended_header__qsybU"};